// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"245":"e3444e06","615":"1f10d906","720":"7a0e8f45","785":"3188a708","810":"99abe4e5"}[chunkId] + ".chunk.css";
};